import { render, staticRenderFns } from "./DealProposalList.vue?vue&type=template&id=08db2219&scoped=true&"
import script from "./DealProposalList.vue?vue&type=script&lang=js&"
export * from "./DealProposalList.vue?vue&type=script&lang=js&"
import style0 from "./DealProposalList.vue?vue&type=style&index=0&id=08db2219&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08db2219",
  null
  
)

export default component.exports